"use strict";
// Debt type definitions — the single source-of-truth contract for the Debt
// Eliminator, shared by web (Vite) and mobile (Expo, Phase 2C).
//
// These are the UI-facing camelCase shapes. The web API layer
// (frontend/src/api/debts.ts) mirrors the backend's snake_case response and
// adapts it onto these types; mobile will do the same. Monetary values are
// JS numbers here (the adapter parses the backend's Decimal strings).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=debt.js.map